export enum TableHeadingFormAudience {
  NAME = 'full_name',
  PERSONALITY = 'personality_name',
  COMPANY = 'company_name',
  Submitted = 'created_on',
  ORIGIN_DOMAIN = 'origin_domain'
}

export const internalFieldMappings = {
  'Email Address': 'email',
  'First Name': 'first_name',
  'Middle Name': 'middle_name',
  'Full Name': 'full_name',
  'Last Name': 'last_name',
  'Phone Number': 'phone_number',
  'Company Name': 'company_name',
  'Company Revenue': 'company_revenue',
  'Company Location': 'company_location',
  'Job Title': 'job_title',
  Address: 'address',
  'Industry/Business Type': 'industry',
  'Website URL': 'website_url',
  'Social Media Profiles': 'social_links',
  'Lead Source': 'lead_source',
  'IP Address': 'ip',
  'Country' : 'country',
};

export const internalFields = [
  { value: 'First Name', label: 'First Name' },
  { value: 'Middle Name', label: 'Middle Name' },
  { value: 'Last Name', label: 'Last Name' },
  { value: 'Full Name', label: 'Full Name' },
  { value: 'Email Address', label: 'Email Address' },
  { value: 'Phone Number', label: 'Phone Number' },
  { value: 'Company Name', label: 'Company Name' },
  { value: 'Company Revenue', label: 'Company Revenue' },
  { value: 'Company Location', label: 'Company Location' },
  { value: 'Job Title', label: 'Job Title' },
  { value: 'Address', label: 'Address' },
  { value: 'Industry/Business Type', label: 'Industry/Business Type' },
  { value: 'Website URL', label: 'Website URL' },
  { value: 'Social Media Profiles', label: 'Social Media Profiles' },
  { value: 'Lead Source', label: 'Lead Source' },
  { value: 'IP Address', label: 'IP Address' },
  { value: 'Consent and Opt-In', label: 'Consent and Opt-In' },
  { value: 'Country', label: 'Country' },
];
export const formats = [
  { value: 'Text', label: 'Text' },
  { value: 'Number', label: 'Number' },
  { value: 'Date', label: 'Date' },
  { value: 'Radio Button', label: 'Radio Button' },
  { value: 'Checkbox', label: 'Checkbox' },
  { value: 'Dropdown', label: 'Dropdown' },
];

export const FORM_HANDLER_USER_GUIDE = 'https://xiqinc.com/wp-content/themes/xiqInc/pdf/form-handlers.pdf';
